/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTenFeet56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M41.946 14.838h-3.314v-.596c0-1.005.539-1.434 1.802-1.434.497 0 .973.038 1.512.13v-2.233a10.127 10.127 0 00-2.05-.205c-3.19 0-4.805 1.247-4.805 3.705v.633h-2.278v2.085h2.278v7.223h3.541v-7.223h3.314v-2.085z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.927 17.686c0 4.264-2.795 6.814-7.144 6.814s-7.123-2.55-7.123-6.814c0-4.282 2.774-6.832 7.123-6.832s7.144 2.55 7.144 6.832zm-10.581 0c0 2.904 1.346 4.394 3.437 4.394 2.112 0 3.458-1.49 3.458-4.394 0-2.923-1.346-4.412-3.458-4.412-2.091 0-3.437 1.49-3.437 4.412z'
      />
      <path
        fill='currentColor'
        d='M10.748 24.146H7.186V15.34c-.6.54-1.719.857-2.961.857H3.5v-2.793h.456c1.967-.037 3.189-.744 3.83-2.197h2.962v12.94zM45.542 16.923h-2.34v-2.085h2.34v-2.216l3.541-1.191v3.407H52.5v2.085h-3.417v3.258c0 1.098.642 1.638 1.947 1.638.6 0 1.076-.074 1.47-.149v2.42a10.43 10.43 0 01-2.402.261c-3.169 0-4.556-1.21-4.556-3.463v-3.965z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.75 32.5v12h50.5v-12H2.75zM4.25 43v-9h4.625v3.625h1.5V34h3.75v3.625h1.5V34h3.75v5.375h1.5V34h3.75v3.625h1.5V34h3.75v3.625h1.5V34h3.75v5.375h1.5V34h3.75v3.625h1.5V34h3.75v3.625h1.5V34h4.625v9H4.25z'
      />
    </svg>
  );
}

export default SvgTenFeet56;
